import { USER_ROLE } from "../../commons/enum";
import { useMyInfo } from "../../hooks/user.hooks";
import { navigateToDomainWithLocalStorageData } from "../../utils/domain-navigation";
import { getAllValueLocationStorage } from "../../utils/locastorage-utils";

export const DashboardLogicWrapper = ({ children }) => {
  const { data: myInfo, isSuccess: isGetMyInfoSuccess } = useMyInfo();

  if (!isGetMyInfoSuccess) return null;

  if (myInfo.isAllowToAccessBackoffice) {
    return children;
  }

  const localStorageData = getAllValueLocationStorage();
  navigateToDomainWithLocalStorageData(
    myInfo.originCompanyDomain,
    localStorageData,
    myInfo.userRole !== USER_ROLE.USER
  );
  return null;
};
